import { render, staticRenderFns } from "./FieldType21.vue?vue&type=template&id=beb66752&scoped=true"
import script from "./FieldType21.vue?vue&type=script&lang=js"
export * from "./FieldType21.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb66752",
  null
  
)

export default component.exports